import { render } from "./page-2.5.vue?vue&type=template&id=474a9b6d&scoped=true"
import script from "./page-2.5.vue?vue&type=script&lang=js"
export * from "./page-2.5.vue?vue&type=script&lang=js"

import "./page-2.5.vue?vue&type=style&index=0&id=474a9b6d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474a9b6d"]])

export default __exports__